import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "./ui/card";
import { Dialog, DialogContent } from "../components/ui/dialog";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { Label } from "./ui/label";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";
import { Cake, DollarSign, Ruler } from "lucide-react"; // Add these imports
import {
  ArrowLeft,
  Heart,
  MessageCircle,
  Share2,
  MapPin,
  GraduationCap,
  Briefcase,
  Shield,
  Star,
  Camera,
  Flag,
  Menu,
  Crown,
  User,
  X,
  Instagram,
} from "lucide-react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";
import { ImageWithFallback } from "./figma/ImageWithFallback";
import { sampleProfiles } from "../constants/profiles";
import { InterestModal } from "./InterestModal";
import { MessageModal } from "./MessageModal";
import { useLocation, useNavigate } from "react-router-dom";
import { CircleSlash } from "lucide-react";
import {
  deleteWithTokenAPI,
  deleteWithTokenBodyAPI,
  getWithoutTokenAPI,
  getWithTokenAPI,
  postWithTokenAPI,
} from "../util/Api";
import { useSelector, useDispatch } from "react-redux";
import { clearUserState } from "../redux/userSlice";
import { Textarea } from "./ui/textarea"; // Add this import if you have a Textarea component
import { Header } from "./Header";
import { setCurrentPage } from "../redux/navigationSlice.js";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import "../styles/ProfileviewPAge.css";

export function ProfileViewPage({ onNavigate, profileId }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("overview");
  const [sentInterest, setsentInterest] = useState(false);
  const [isInterestSent, setIsInterestSent] = useState(false);
  const [showInterestModal, setShowInterestModal] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [showReportDialog, setShowReportDialog] = useState(false);
  const [SandMeg, setSandMeg] = useState(false);
  const [message, setMessage] = useState("");
  const data = useSelector((state) => state.user);
  const token = data?.userId?.accessToken;
  const location = useLocation();
  const id = location.state?.profileId;
  const { name } = useParams();
  const { t, i18n } = useTranslation();
  const userid = data?.userId?.user?._id;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [profileDetails, setProfileDetails] = useState({});
  const [profileimage, setProfileimage] = useState("");

  const [fullscreenImage, setFullscreenImage] = useState(null);

  const [isTwoColumn, setIsTwoColumn] = useState(false);

  const [userSubscription, setUserSubscription] = useState({
    plan_id: "",
    plan_price: "",
    plan_name: "",
  });

    useEffect(() => {
      const fetchProfile = async () => {
        try {
          const response = await getWithTokenAPI(
            token,
            `/user-id/get_by_id?user_id=${userid}`
          );
            const subpack = response?.data?.subscription;
  
          if (subpack) {
            setUserSubscription({
              plan_id: subpack.plan_id || "",
              plan_price: subpack.price || "",
              plan_name: subpack.plan_name || "",
            });
          }
        } catch (error) {
          console.error("Error fetching profile:", error);
        }
      };
  
      if (userid && token) fetchProfile();
    }, [userid, token]);

  useEffect(() => {
    const handleResize = () => {
      setIsTwoColumn(window.innerWidth >= 600 && window.innerWidth < 800);
    };

    // Check initially
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const capitalize = (str) => {
    if (typeof str !== "string" || !str) return "";
    else if (str.length > 1) return str.charAt(0).toUpperCase() + str.slice(1);
    else return str.toUpperCase();
  };

  function timeAgo(dateString) {
    const seconds = Math.floor((new Date() - new Date(dateString)) / 1000);

    if (seconds < 60) return "just now";
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} min ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    const days = Math.floor(hours / 24);
    return `${days} day${days > 1 ? "s" : ""} ago`;
  }

  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const handleLogout = () => {
    setShowLogoutDialog(true);
  };
  const [header, setHeader] = useState(null);
  const [subpack, setSubsPack] = useState("");
  const [completion, setCompletion] = useState(0);

  const [report, setReport] = useState("");

  console.log(report, "report");

  const fetchReport = async () => {
    if (!id) {
      console.warn("No profileId provided. Skipping fetch.");
      return;
    }
    try {
      const response = await getWithTokenAPI(
        token,
        `/reports/get-by-id?user_id=${userid}`
      );
      if (response) {
        const matchedReports =
          response?.data?.reports?.filter(
            (report) => report.reported_user_id === id
          ) || [];
        setReport(matchedReports?.length > 0);
      } else {
        toast.error(`${t("No Profile Data")}`);
        console.warn("No profile data found for this user.");
      }
    } catch (error) {
      console.error("❌ Error fetching profile details:", error);
    }
  };

  useEffect(() => {
    fetchReport();
  }, []);

  useEffect(() => {
    const fetchInterests = async () => {
      try {
        const sentresponse = await getWithTokenAPI(
          token,
          `/interest/get_send_interest?user_id=${userid}`
        );

        if (sentresponse?.data?.receivers) {
          const receivers = sentresponse.data.receivers;

          // ✅ Check if the viewed profile already received interest from this user
          const isAlreadySent = receivers.some((item) => item.user_id === id);
          setsentInterest(isAlreadySent);
        } else {
          setsentInterest(false);
        }
      } catch (error) {
        console.error("Error fetching interests:", error);
        setsentInterest(false);
      }
    };

    if (id && token && userid) {
      fetchInterests();
    }
  }, [id, sentInterest]);
  //----------fix image url-------------
  const fixImageUrl = (url) => {
    if (!url) return "";
    return url.replace(
      "s3.eu-north-1.amazonaws.com",
      "s3.ap-south-1.amazonaws.com"
    );
  };
  const [profileData, setprofileData] = useState("");
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `/user-id/get_by_id?user_id=${userid}`
        );
        setprofileData(response?.data?.profile?.name);
        setSubsPack(response?.data?.subscription?.plan_name);
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };
    if (id && token) {
      fetchProfile();
    }
  }, [id, token]); // ✅ Proper dependencies

  useEffect(() => {
    const fetchProfileDetails = async () => {
      if (!id) {
        console.warn("No profileId provided. Skipping fetch.");
        // setIsEditing(true)
        return;
      }
      try {
        console.log("Fetching profile for user:", id);
        const response = await getWithTokenAPI(token, `/profile/get_all/${id}`);
        if (response) {
          setProfileDetails(response?.data);
        } else {
          toast.error(`${t("No Profile Data")}`);
          console.warn("No profile data found for this user.");
        }
      } catch (error) {
        console.error("❌ Error fetching profile details:", error);
      }
    };

    if (token && id) {
      fetchProfileDetails();
    }
  }, [token, id]);

  // const handleSendMessage = () => {
  //   setShowMessageModal(true);
  // };
  // const [galleryUrl, setGalleryUrl] = useState([]);
  // console.log(galleryUrl, "GALLERYURL");
  // useEffect(() => {
  //   const fetchpimages = async () => {
  //     const imageresponse = await getWithTokenAPI(
  //       token,
  //       //`/document/user/${id}`
  //       `/document/user/${id}`
  //     );
  //     console.log(
  //       "Imageresponse-------------------------------",
  //       imageresponse?.data
  //     );
  //     setGalleryUrl(imageresponse?.data || []);
  //   };
  //   fetchpimages();
  // }, [id, token]);

  const buttonStyle = {
    width: "100%",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "16px",
    borderRadius: "16px",
    transition: "all 0.3s",
    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
    border: "0",
    padding: "7px 16px",
    background:
      isInterestSent || sentInterest
        ? "linear-gradient(to right, #10B981, #22C55E)" // emerald → green
        : "linear-gradient(to right, #EC4899, #F43F5E)", // pink → rose
    color: "white",
  };

  const handleSendMessage = async () => {
    const payload = {
      sender_id: userid,
      receiver_id: id,
      content: "",
    };
    const response = await postWithTokenAPI(token, `/message/send`, payload);
    if (response?.statusCode == 200) {
      navigate("/messages");
    }
    if (response?.statusCode == 403) {
      setSandMeg(true);
    }
  };

  const RemoveReport = async () => {
    try {
      const response = await deleteWithTokenAPI(
        token,
        `/reports/delete?profile_id=${id}&user_id=${userid}  `
      );

      if (response?.statusCode === 200) {
        toast.success("Report removed successfully!");
        fetchReport();
      } else {
        toast.error("Failed to remove report.");
      }
    } catch (error) {
      console.error("❌ Error removing report:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };
  const isMobile = window.innerWidth < 768;
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <Toaster position="top-right" />
      <Header />

      <Helmet>
        <title>Avan Aval - View Profile</title>
        <meta name="description" content={`Profile page of ${name}`} />
        <meta name="keywords" content={`Profile, ${name}, Avan Aval`} />
      </Helmet>

      <div className=" bg-card">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-4">
              <Button
                variant="ghost"
                onClick={() => {
                  navigate(-1);
                }}
                className="text-gray-600 text-lg font-semibold mt-2  cursor-pointer"
              >
                <ArrowLeft className="w-5 h-5 mb-1" />
                {t("Back")}
              </Button>
            </div>
            <div className="flex items-center gap-2">
              {report ? (
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => RemoveReport()}
                  className="cursor-not-allowed opacity-60"
                >
                  <CircleSlash className="w-4 h-4 mr-2 text-red-600" />
                  {/* {t("Reported")} */}
                  Reported
                </Button>
              ) : (
                // Not reported → Enable
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => setShowReportDialog(true)}
                  className="cursor-pointer"
                >
                  <Flag className="w-4 h-4 mb-1 mr-1" />
                  {t("Report")}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Main Layout */}
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
        <div className="Main-Layout-containe">
          <div className="card-25">
            <Card
              className="overflow-hidden border-4 rounded-[20px] shadow-sm rounded-3xl bg-gradient-to-br from-white to-gray-50/50 mb-3"
              style={{ borderRadius: "20px" }}
              // className="mb-3"
            >
              <CardContent
                className="space-y-3 mt-2"
                style={{ borderRadius: "10px" }}
              >
                <div className="text-left space-y-3">
                  <div
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    
                    <div
                      style={{
                        width: "70%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Avatar
                        className=" border-white shadow-2xl  flex-shrink-0"
                        style={{
                          width: "100%",
                          maxWidth: "200px",
                          height: "100%",
                          maxHeight: "170px",
                          border: "1px solid gainsboro",
                          borderRadius: "20px",
                        }}
                      >
                        <AvatarImage
                          style={{ borderRadius: "10px" }}

                          src={profileDetails?.basicProfile?.profileImage}
                          className="object-contain bg-gray-100 rounded-[10px]"
                        />
                        <AvatarFallback
                          className="text-3xl bg-gradient-to-br from-pink-100 to-rose-100 text-rose-600"
                          style={{
                            width: "100%",
                            maxWidth: "200px",
                            height: "150px",
                            border: "1px solid gainsboro",
                            borderRadius: "20px",
                          }}
                        >
                          {profileDetails?.basicProfile?.name
                            ?.split(" ")
                            .map((n) => n[0])
                            .join("")}
                        </AvatarFallback>
                      </Avatar>
                    </div>

                    <div
                      style={{
                        width: "60%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-evenly",
                        alignItems: "flex-start",
                        paddingLeft: "5px",
                      }}
                    >
                      <span className=" ml-2 flex flex-col lg:flex-row">
                        <h1
                          className="text-3xl text-bold font-extrabold bg-gradient-to-r from-gray-900 to-gray-600 
                                   bg-clip-text text-transparent tracking-tight leading-snug"
                        >
                          {profileDetails?.basicProfile?.name}
                        </h1>
                        <p className="mt-1 text-lg text-gray-400">
                          {profileDetails?.basicProfile?.age} {t("years old")}
                        </p>
                      </span>

                      <div className="grid grid-cols-1 gap-1 max-w-sm ">
                        <div className="flex items-center gap-2 bg-white">
                          <div className={`ml-1 p-1`}>
                            <i
                              className={`text-md ${
                                profileDetails?.basicProfile?.gender === "Male"
                                  ? "text-blue-600 fa-solid fa-mars"
                                  : profileDetails?.basicProfile?.gender ===
                                    "Female"
                                  ? "text-red-600 fa-solid fa-venus"
                                  : "text-purple-600 fa-solid fa-transgender"
                              }`}
                            ></i>
                          </div>
                          <span className="font-medium text-gray-700">
                            {profileDetails?.basicProfile?.gender}
                          </span>
                        </div>
                        <div className="flex items-center gap-3 bg-white">
                          <div className="p-2 bg-blue-50 rounded-xl">
                            <MapPin className="w-4 h-4 text-blue-600" />
                          </div>
                          <span className="font-medium text-gray-700 ">
                            {profileDetails?.basicProfile?.district}
                          </span>
                        </div>

                        {profileDetails?.professionalProfile?.profession && (
                          <div className="flex items-center gap-3 bg-white">
                            <div className="p-2 bg-green-50 rounded-xl">
                              <Briefcase className="w-4 h-4 text-green-600" />
                            </div>
                            <span className="font-medium text-gray-700">
                              {profileDetails?.professionalProfile?.profession}
                            </span>
                          </div>
                        )}

                        {profileDetails?.professionalProfile?.education && (
                          <div className="flex items-center gap-3 bg-white">
                            <div className="p-2 bg-purple-50 rounded-xl">
                              <GraduationCap className="w-4 h-4 text-purple-600" />
                            </div>
                            <span className="font-medium text-gray-700">
                              {profileDetails?.professionalProfile?.education}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="pt-3 flex flex-col sm:flex-row gap-3 max-w-sm mx-auto w-full">
                    <Button
                      size="lg"
                      style={buttonStyle}
                      className="flex-1 min-w-0 max-w-full   flex items-center justify-center gap-1 cursor-pointer font-semibold rounded-2xl border-2 border-gray-300 text-gray-700 transition-all duration-300 shadow-sm"
                      onClick={async () => {
                        if (isInterestSent || sentInterest) {
                          try {
                            const payload = {
                              from_user_id: userid,
                              to_user_id: id,
                            };
                            const response = await deleteWithTokenBodyAPI(
                              token,
                              `/interest/delete`,
                              payload
                            );

                            if (response?.statusCode === 200) {
                              setIsInterestSent(false);
                              toast.success(
                                `${t("Interest Deleted Successfully")}`
                              );
                            }
                          } catch (error) {
                            toast.error(`${t("Already Deleted interest")}`);
                          }
                        } else {
                          try {
                            const payload = {
                              from_user_id: userid,
                              to_user_id: id,
                            };
                            const response = await postWithTokenAPI(
                              token,
                              `/interest/create`,
                              payload
                            );

                            if (response?.statusCode === 200) {
                              setIsInterestSent(true);
                              toast.success(
                                `${t("Interest Sent Successfully")}`
                              );
                            }
                          } catch (error) {
                            toast.error(`${t("Interest Already Sent")}`);
                          }
                        }
                      }}
                    >
                      <Heart className="w-5 h-5 shrink-0 mb-1" />
                      <span className="text-center font-medium text-sm">
                        {isInterestSent || sentInterest
                          ? t("Interest Sent")
                          : t("Send Interest")}
                      </span>
                    </Button>

                    {/* Message Button */}
                    <Button
                      variant="outline"
                      size="lg"
                      id="Message"
                      className="flex-1 min-w-0 max-w-full flex items-center justify-center gap-1 cursor-pointer font-semibold  rounded-2xl border-2 border-gray-300 text-gray-700 transition-all duration-300 shadow-sm"
                      onClick={handleSendMessage}
                    >
                      <MessageCircle className="w-5 h-5 shrink-0 mb-1" />
                      <span className="text-center font-medium text-sm">
                        {t("Send Message")}
                      </span>
                    </Button>
                  </div>

                  {/* Status Info - Modern Design */}
                  <div className=" pt-2 grid grid-cols-2 gap-4 text-sm max-w-sm mx-auto">
                    <div className="text-center p-3 bg-blue-50 rounded-2xl">
                      <p className="font-semibold text-blue-700">
                        {t("Last Active")}
                      </p>
                      <p className="text-black font-medium">
                        {timeAgo(profileDetails?.basicProfile?.updatedAt)}
                      </p>
                    </div>
                    <div className="text-center p-3 bg-purple-50 rounded-2xl">
                      <p className="font-semibold text-purple-600">
                        {t("Joined")}
                      </p>
                      <p className="text-black font-medium">
                        {new Date(
                          profileDetails?.basicProfile?.createdAt
                        ).toLocaleDateString("default", {
                          month: "short",
                          year: "numeric",
                        })}
                      </p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className=" w-full mx-2 flex justify-between align-center text-lg">
                  <span className="py-1 flex align-center ">
                    <User className="w-5 h-5 text-lg mr-2" />
                    {t("Basic Info")}
                  </span>{" "}
                  {profileDetails?.professionalProfile?.instagram && (
                    <i
                      className="fa-brands fa-instagram text-2xl text-red-500 cursor-pointer hover:scale-110 transition-all"
                      onClick={() => {
                        const instagramUsername =
                          profileDetails?.professionalProfile?.instagram;

                        if (!instagramUsername) {
                          console.log("No Instagram username available");
                          toast.error(`${t("Invalid Instagram username")}`);
                          return;
                        }

                        // Clean the username
                        const cleanUsername = instagramUsername
                          .replace("@", "")
                          .replace("https://www.instagram.com/", "")
                          .replace("https://instagram.com/", "")
                          .replace("http://www.instagram.com/", "")
                          .replace("http://instagram.com/", "")
                          .trim();

                        // Construct URL
                        const instagramUrl = `https://www.instagram.com/${cleanUsername}`;

                        // Open in new tab
                        window.open(
                          instagramUrl,
                          "_blank",
                          "noopener,noreferrer"
                        );
                      }}
                    ></i>
                  )}
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                 {profileDetails?.basicProfile?.mobile_number && userSubscription?.plan_price > 0 && (
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">{t("Contact Info")}</span>
                    <span className="font-medium">
                      {profileDetails?.basicProfile?.mobile_number}
                    </span>
                  </div>
                )}

                 {profileDetails?.professionalProfile?.father_name && (
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">{t("Father")}</span>
                    <span className="font-medium">
                      {profileDetails?.professionalProfile?.father_name}
                    </span>
                  </div>
                )}

               
                {profileDetails?.professionalProfile?.mother_name && (
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">{t("Mother")}</span>
                    <span className="font-medium">
                      {profileDetails?.professionalProfile?.mother_name}
                    </span>
                  </div>
                )}
                {profileDetails?.professionalProfile?.income && (
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">{t("Income")}</span>
                    <span className="font-medium">
                      Rs.{profileDetails?.professionalProfile?.income}
                    </span>
                  </div>
                )}
                {profileDetails?.professionalProfile?.motherTongue && (
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">
                      {t("Mother Tongue")}
                    </span>
                    <span className="font-medium">
                      {profileDetails?.professionalProfile?.motherTongue}
                    </span>
                  </div>
                )}
                {profileDetails?.professionalProfile?.height && (
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">{t("Height")}</span>
                    <span className="font-medium">
                      {profileDetails?.professionalProfile?.height} cm
                    </span>
                  </div>
                )}
                {profileDetails?.professionalProfile?.weight && (
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">{t("Weight")}</span>
                    <span className="font-medium">
                      {profileDetails?.professionalProfile?.weight}
                    </span>
                  </div>
                )}
                {profileDetails?.professionalProfile?.diet && (
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">{t("Diet")}</span>
                    <span className="font-medium">
                      {profileDetails?.professionalProfile?.diet}
                    </span>
                  </div>
                )}

                {profileDetails?.basicProfile?.religion && (
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">
                      {t("Religion")}
                    </span>
                    <span className="font-medium">
                      {profileDetails?.basicProfile?.religion}
                    </span>
                  </div>
                )}

                {profileDetails?.basicProfile?.caste && (
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">{t("Caste")}</span>
                    <span className="font-medium">
                      {profileDetails?.basicProfile?.caste}
                    </span>
                  </div>
                )}
                {profileDetails?.basicProfile?.maritalStatus && (
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">
                      {t("Marital Status")}
                    </span>
                    <span className="font-medium">
                      {profileDetails?.basicProfile?.maritalStatus}
                    </span>
                  </div>
                )}
                {profileDetails?.basicProfile?.child_count &&
                  profileDetails?.basicProfile?.maritalStatus != "Single" && (
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">
                        {t("Children")}
                      </span>
                      <span className="font-medium">
                        {profileDetails?.basicProfile?.child_count}
                      </span>
                    </div>
                  )}
                {profileDetails?.professionalProfile?.siblings && (
                  <div className="w-full flex flex-row justify-between">
                    <span className="text-muted-foreground">{t("Siblings")}</span>
                    <span className="font-medium">
                      {profileDetails?.professionalProfile?.siblings}
                    </span>
                  </div>
                )}
              </CardContent>
            </Card>
          </div>
          <div className="card-75">
            <Tabs value={activeTab} onValueChange={setActiveTab}>
              <TabsList className="grid w-full grid-cols-3">
                <TabsTrigger value="overview" className="cursor-pointer">
                  {t("Overview")}
                </TabsTrigger>
                <TabsTrigger value="photos" className="cursor-pointer">
                  {t("Photos")}
                </TabsTrigger>
                <TabsTrigger value="horoscope" className="cursor-pointer">
                  {t("Horoscope")}
                </TabsTrigger>
              </TabsList>

              <TabsContent value="overview" className="space-y-6">
                {(profileDetails?.professionalProfile?.aboutMe ||
                  profileDetails?.professionalProfile?.about_partner) && (
                  <Card className="grid grid-row px-4 py-4 gap-4">
                    {profileDetails?.professionalProfile?.aboutMe && (
                      <div className="bg-white w-full mx-3 border border-gray-300 rounded-lg">
                        <CardHeader>
                          <CardTitle className="text-lg font-semibold">
                            {t("About Me")}
                          </CardTitle>
                        </CardHeader>
                        <CardContent>
                          <p className="leading-relaxed">
                            {profileDetails?.professionalProfile?.aboutMe}
                          </p>
                        </CardContent>
                      </div>
                    )}
                    {/* 
                    {profileDetails?.professionalProfile?.siblings && (
                      <div className="bg-white border-l border-gray-300 rounded-lg ">
                        <CardHeader>
                          <CardTitle className="text-lg font-semibold">
                            {t("Sibling")}
                          </CardTitle>
                        </CardHeader>
                        <CardContent>
                          <p className="leading-relaxed">
                            {profileDetails?.professionalProfile?.siblings}
                          </p>
                        </CardContent>
                      </div>
                    )} */}

                    {profileDetails?.professionalProfile?.property_details && (
                      <div className="bg-white w-full mx-3 border border-gray-300 rounded-lg">
                        <CardHeader>
                          <CardTitle className="text-lg font-semibold">
                            {t("Property Details")}
                          </CardTitle>
                        </CardHeader>
                        <CardContent>
                          <p className="leading-relaxed">
                            {
                              profileDetails?.professionalProfile
                                ?.property_details
                            }
                          </p>
                        </CardContent>
                      </div>
                    )}
                  </Card>
                )}

                <Card>
                  <CardHeader>
                    <CardTitle className="text-lg font-semibold text-gray-900">
                      {t("Partner Preferences")}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-3">
                      {Object.entries(profileDetails?.preference || {})
                        .filter(
                          ([key]) =>
                            ![
                              "user_id",
                              "_id",
                              "__v",
                              "createdAt",
                              "updatedAt",
                              "pref_completed",
                              "is_deleted",
                              "about_partner",
                            ].includes(key)
                        )
                        // .filter(
                        //   ([_, value]) =>
                        //     value && (!Array.isArray(value) || value.length > 0)
                        // )
                        .filter(([_, value]) => {
                          // Check if value exists and is not empty
                          if (!value && value !== 0 && value !== false)
                            return false;

                          // Handle arrays - check if any non-empty items exist
                          if (Array.isArray(value)) {
                            return value.some(
                              (item) => item && item.toString().trim() !== ""
                            );
                          }

                          // Handle strings - check not empty or whitespace
                          if (typeof value === "string") {
                            return value.trim() !== "";
                          }

                          // For all other types (numbers, booleans, objects)
                          return true;
                        })
                        .map(([key, value]) => (
                          <div
                            key={key}
                            className="bg-white border border-gray-300 rounded-lg p-3 hover:border-blue-400 hover:shadow-sm transition-all"
                          >
                            <h3 className="text-sm font-semibold text-gray-800 capitalize mb-2 truncate">
                              {capitalize(key.replaceAll("_", " "))}
                            </h3>

                            {Array.isArray(value) ? (
                              <div className="flex flex-wrap gap-1">
                                {value
                                  .filter(
                                    (item) =>
                                      item && item.toString().trim() !== ""
                                  )
                                  .map((v, i) => (
                                    <span
                                      key={i}
                                      className="inline-block bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded border border-gray-200 truncate max-w-full"
                                    >
                                      {typeof v === "string"
                                        ? capitalize(v)
                                        : v}
                                    </span>
                                  ))}
                              </div>
                            ) : typeof value === "object" &&
                              value !== null &&
                              value !== " " &&
                              value != [" "] ? (
                              <div className="space-y-1 text-xs">
                                {Object.entries(value).map(
                                  ([subKey, subVal]) => (
                                    <div
                                      key={subKey}
                                      className="flex justify-between"
                                    >
                                      <span className="text-gray-600 capitalize">
                                        {capitalize(subKey)}
                                      </span>
                                      <span className="font-medium text-gray-800">
                                        {subVal}
                                      </span>
                                    </div>
                                  )
                                )}
                              </div>
                            ) : (
                              <span className="text-sm  text-grey-600">
                                {typeof value === "string"
                                  ? capitalize(value)
                                  : value}
                              </span>
                            )}
                          </div>
                        ))}
                    </div>
                    {profileDetails?.preference?.about_partner && (
                      <Card className="mt-3">
                        <CardContent>
                          <h3 className="text-md font-semibold text-gray-800 capitalize mt-2 truncate">
                            About Partner
                          </h3>
                          <p className="leading-relaxed mt-2">
                            {profileDetails?.preference?.about_partner}
                          </p>
                        </CardContent>
                      </Card>
                    )}
                  </CardContent>
                </Card>
              </TabsContent>

              <TabsContent value="photos">
                <Card>
                  <CardHeader>
                    <CardTitle className="text-lg font-semibold">
                      {t("Photo Gallery")}
                    </CardTitle>
                    <CardDescription>
                      {profileDetails?.professionalProfile?.gallery?.length}{" "}
                      {t(" photos available")}
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    {/* <Avatar className="grid grid-cols-2 md:grid-cols-3 gap-4">
                      {profileData?.professionalProfile?.gallery.map((photo, index) => (
                        <div key={index} className="relative group">
                          <AvatarImage
                            src={fixImageUrl(photo)}
                            alt={`${profileDetails?.basicProfile?.name} photo ${index + 1
                              }`}
                            className="w-full h-48 object-cover rounded-lg hover:scale-105 transition-transform"
                            onClick={() =>
                              setFullscreenImage(photo)
                            }
                          />
                        </div>
                      ))}

                    </Avatar> */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
                      {(profileDetails?.professionalProfile?.gallery || [])
                        .filter(Boolean)
                        .map((photo, index) => (
                          <Avatar
                            key={index}
                            className="w-full h-48 border-4 border-white shadow-xl rounded-[20px]"
                          >
                            <AvatarImage
                              style={{ borderRadius: "10px" }}
                              // src={fixImageUrl(photo)}
                              src={photo.url}
                              className="object-contain bg-gray-100 w-full h-full rounded-[10px] cursor-pointer"
                              onClick={() => setFullscreenImage(photo)}
                            />
                            <AvatarFallback className="text-3xl bg-gradient-to-br from-pink-100 to-rose-100 text-rose-600 rounded-[10px]">
                              {profileDetails?.basicProfile?.name
                                ?.split(" ")
                                .map((n) => n[0])
                                .join("")}
                            </AvatarFallback>
                          </Avatar>
                        ))}
                    </div>
                  </CardContent>
                </Card>
              </TabsContent>

              <TabsContent value="horoscope">
                <Card>
                  <CardHeader>
                    <CardTitle className="text-lg font-semibold">
                      {t("Horoscope Details")}
                    </CardTitle>
                  </CardHeader>

                  {/* First Row: Astrology Details + Planet Codes */}
                  <CardContent>
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                      {/* Left: Astrology Details */}
                      <div className="space-y-4">
                        <h3 className="text-lg font-semibold text-gray-900">
                          Astrology Information
                        </h3>
                        <div className="grid grid-cols-2 sm:grid-cols-2 gap-3">
                          {Object.entries(
                            profileDetails?.professionalProfile?.astrology || {}
                          )
                            .filter(([_, value]) => value)
                            .map(([key, value]) => (
                              <div
                                key={key}
                                className="bg-gradient-to-br from-white to-blue-50 border border-blue-100 rounded-xl p-4 hover:shadow-lg transition-all duration-300"
                              >
                                <div className="flex items-center justify-between">
                                  <div>
                                    <div className="text-sm font-bold text-purple-700 capitalize">
                                      {capitalize(key.replaceAll("_", " "))}
                                    </div>
                                    <div className="text-md font-medium text-blue-600 mt-1">
                                      {typeof value === "string"
                                        ? capitalize(value)
                                        : value}
                                    </div>
                                  </div>
                                  <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                                    <Star className="w-4 h-4 text-blue-600" />
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>

                      {/* Right: Planet Codes */}
                      <div className="space-y-4">
                        <h3 className="text-lg font-semibold text-gray-900">
                          Planet Codes Reference
                        </h3>
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                          {[
                            { tamil: "புதன்", code: "pu" },
                            { tamil: "சந்திரன்", code: "chan" },
                            { tamil: "சுக்ரன்", code: "chk" },
                            { tamil: "சூரியன்", code: "sun" },
                            { tamil: "வியாழன்", code: "viy" },
                            { tamil: "குரு", code: "gu" },
                            { tamil: "செவ்வாய்", code: "sev" },
                            { tamil: "கேது", code: "kee" },
                            { tamil: "லக்னம்", code: "lac" },
                            { tamil: "ராகு", code: "ragu" },
                            { tamil: "சனி", code: "sat" },
                          ].map((planet, index) => (
                            <div
                              key={index}
                              className="bg-white border border-gray-200 rounded-lg p-3 text-center hover:shadow-md hover:border-blue-300 transition-all duration-200"
                            >
                              <div className="text-xs text-gray-600 mb-1">
                                {planet.tamil}
                              </div>
                              <div className="text-sm font-mono font-bold text-blue-600">
                                {planet.code}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </CardContent>

                  {/* Second Row: Zodiac Boxes */}
                  <CardContent>
                    <div className="space-y-4">
                      <h3 className="text-lg font-semibold text-gray-900">
                        Zodiac Charts
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* Rasi Box */}
                        <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm hover:shadow-md transition-all duration-300">
                          <h3 className="text-center text-lg font-semibold text-blue-600 mb-4">
                            {t("Rasi Chart")}
                          </h3>
                          <div className="zodiac-4x4-grid">
                            <div className="zodiac-grid-row">
                              <input
                                type="text"
                                className="zodiac-box house-1"
                                value={profileDetails?.zodiac?.rasi?.House_1}
                                readOnly
                                placeholder="1"
                              />
                              <input
                                type="text"
                                className="zodiac-box house-2"
                                value={profileDetails?.zodiac?.rasi?.House_2}
                                readOnly
                                placeholder="2"
                              />
                              <input
                                type="text"
                                className="zodiac-box house-3"
                                value={profileDetails?.zodiac?.rasi?.House_3}
                                readOnly
                                placeholder="3"
                              />
                              <input
                                type="text"
                                className="zodiac-box house-4"
                                value={profileDetails?.zodiac?.rasi?.House_4}
                                readOnly
                                placeholder="4"
                              />
                            </div>
                            <div className="zodiac-grid-row">
                              <input
                                type="text"
                                className="zodiac-box house-12"
                                value={profileDetails?.zodiac?.rasi?.House_12}
                                readOnly
                                placeholder="12"
                              />
                              <div className="zodiac-empty-cell"></div>
                              <div className="zodiac-empty-cell"></div>
                              <input
                                type="text"
                                className="zodiac-box house-5"
                                value={profileDetails?.zodiac?.rasi?.House_5}
                                readOnly
                                placeholder="5"
                              />
                            </div>
                            <div className="zodiac-grid-row">
                              <input
                                type="text"
                                className="zodiac-box house-11"
                                value={profileDetails?.zodiac?.rasi?.House_11}
                                readOnly
                                placeholder="11"
                              />
                              <div className="zodiac-empty-cell">
                                <span className="zodiac-center-text text-blue-600 font-medium">
                                  {t("Rasi")}
                                </span>
                              </div>
                              <div className="zodiac-empty-cell"></div>
                              <input
                                type="text"
                                className="zodiac-box house-6"
                                value={profileDetails?.zodiac?.rasi?.House_6}
                                readOnly
                                placeholder="6"
                              />
                            </div>
                            <div className="zodiac-grid-row">
                              <input
                                type="text"
                                className="zodiac-box house-10"
                                value={profileDetails?.zodiac?.rasi?.House_10}
                                readOnly
                                placeholder="10"
                              />
                              <input
                                type="text"
                                className="zodiac-box house-9"
                                value={profileDetails?.zodiac?.rasi?.House_9}
                                readOnly
                                placeholder="9"
                              />
                              <input
                                type="text"
                                className="zodiac-box house-8"
                                value={profileDetails?.zodiac?.rasi?.House_8}
                                readOnly
                                placeholder="8"
                              />
                              <input
                                type="text"
                                className="zodiac-box house-7"
                                value={profileDetails?.zodiac?.rasi?.House_7}
                                readOnly
                                placeholder="7"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Navamsa Box */}
                        <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm hover:shadow-md transition-all duration-300">
                          <h3 className="text-center text-lg font-semibold text-purple-600 mb-4">
                            {t("Navamsa Chart")}
                          </h3>
                          <div className="zodiac-4x4-grid">
                            <div className="zodiac-grid-row">
                              <input
                                type="text"
                                className="zodiac-box house-1"
                                value={profileDetails?.zodiac?.navamsa?.House_1}
                                readOnly
                                placeholder="1"
                              />
                              <input
                                type="text"
                                className="zodiac-box house-2"
                                value={profileDetails?.zodiac?.navamsa?.House_2}
                                readOnly
                                placeholder="2"
                              />
                              <input
                                type="text"
                                className="zodiac-box house-3"
                                value={profileDetails?.zodiac?.navamsa?.House_3}
                                readOnly
                                placeholder="3"
                              />
                              <input
                                type="text"
                                className="zodiac-box house-4"
                                value={profileDetails?.zodiac?.navamsa?.House_4}
                                readOnly
                                placeholder="4"
                              />
                            </div>
                            <div className="zodiac-grid-row">
                              <input
                                type="text"
                                className="zodiac-box house-12"
                                value={
                                  profileDetails?.zodiac?.navamsa?.House_12
                                }
                                readOnly
                                placeholder="12"
                              />
                              <div className="zodiac-empty-cell"></div>
                              <div className="zodiac-empty-cell"></div>
                              <input
                                type="text"
                                className="zodiac-box house-5"
                                value={profileDetails?.zodiac?.navamsa?.House_5}
                                readOnly
                                placeholder="5"
                              />
                            </div>
                            <div className="zodiac-grid-row">
                              <input
                                type="text"
                                className="zodiac-box house-11"
                                value={
                                  profileDetails?.zodiac?.navamsa?.House_11
                                }
                                readOnly
                                placeholder="11"
                              />
                              <div className="zodiac-empty-cell">
                                <span className="zodiac-center-text text-purple-600 font-medium">
                                  {t("Navamsam")}
                                </span>
                              </div>
                              <div className="zodiac-empty-cell"></div>
                              <input
                                type="text"
                                className="zodiac-box house-6"
                                value={profileDetails?.zodiac?.navamsa?.House_6}
                                readOnly
                                placeholder="6"
                              />
                            </div>
                            <div className="zodiac-grid-row">
                              <input
                                type="text"
                                className="zodiac-box house-10"
                                value={
                                  profileDetails?.zodiac?.navamsa?.House_10
                                }
                                readOnly
                                placeholder="10"
                              />
                              <input
                                type="text"
                                className="zodiac-box house-9"
                                value={profileDetails?.zodiac?.navamsa?.House_9}
                                readOnly
                                placeholder="9"
                              />
                              <input
                                type="text"
                                className="zodiac-box house-8"
                                value={profileDetails?.zodiac?.navamsa?.House_8}
                                readOnly
                                placeholder="8"
                              />
                              <input
                                type="text"
                                className="zodiac-box house-7"
                                value={profileDetails?.zodiac?.navamsa?.House_7}
                                readOnly
                                placeholder="7"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </div>
      {/* Report Dialog */}
      <AlertDialog open={showReportDialog} onOpenChange={setShowReportDialog}>
        <AlertDialogContent className="sm:max-w-lg">
          <AlertDialogHeader>
            <AlertDialogTitle>{t("Report Profile")}</AlertDialogTitle>
            <AlertDialogDescription>
              {t(
                "Please describe why you want to report this user. Our team will review it promptly."
              )}
            </AlertDialogDescription>
          </AlertDialogHeader>

          <div className="space-y-3 mt-2 ml-2 center">
            <Label htmlFor="message" className="text-sm font-medium">
              {t("Reason")}
            </Label>
            <Textarea
              id="message"
              placeholder={t("Enter your reason here...")}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="min-h-[100px]"
            />
          </div>

          <AlertDialogFooter className="mt-4">
            <AlertDialogCancel
              onClick={() => {
                setMessage("");
                setShowReportDialog(false);
              }}
              className="cursor-pointer"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
              onClick={async () => {
                if (!message.trim()) {
                  toast.error(
                    `${t("Please enter a reason before submitting.")}`
                  );
                  return;
                }

                try {
                  const payload = {
                    reported_by: userid,
                    profile_id: id,
                    reason: message.trim(),
                  };
                  const response = await postWithTokenAPI(
                    token,
                    "/reports/create",
                    payload
                  );

                  if (response?.statusCode === 200) {
                    toast.success(`${t("Report submitted successfully!")}`);
                    setMessage("");
                    fetchReport(); // NOW THIS WORKS
                    setShowReportDialog(false);
                  } else {
                    toast.error(`${t("Failed to submit report.")}`);
                  }
                } catch (error) {
                  console.error("Error submitting report:", error);
                  toast.error(
                    `${t("Something went wrong. Please try again later.")}`
                  );
                }
              }}
            >
              {t("Submit Report")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog open={SandMeg} onOpenChange={setSandMeg}>
        <AlertDialogContent className="max-w-sm text-center">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-red-600 text-xl font-semibold">
              🔒 {t("Action Not Allowed")}
            </AlertDialogTitle>

            <AlertDialogDescription className="text-gray-600 mt-2">
              {t(
                "This account is blocked. You cannot send a message to this user."
              )}
            </AlertDialogDescription>
          </AlertDialogHeader>

          <div className="flex justify-center gap-3 mt-4">
            <AlertDialogCancel
              onClick={() => setSandMeg(false)}
              className="cursor-pointer border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-lg"
            >
              {t("OK")}
            </AlertDialogCancel>
          </div>
        </AlertDialogContent>
      </AlertDialog>
      {/* Modals */}
      <InterestModal
        isOpen={showInterestModal}
        onClose={() => setShowInterestModal(false)}
        profileName={profileDetails?.basicProfile?.name}
        onSuccess={() => setIsInterestSent(true)}
      />
      <MessageModal
        isOpen={showMessageModal}
        onClose={() => setShowMessageModal(false)}
        profileid={id}
        profileName={profileDetails?.basicProfile?.name}
        userid={userid}
        token={token}
      />
      {fullscreenImage && (
        <Dialog open={true} onOpenChange={() => setFullscreenImage(null)}>
          <DialogContent className="bg-white/80 border-none shadow-none p-0 max-w-[90vw] max-h-[90vh] flex items-center justify-center">
            {/* <button
              onClick={() => setFullscreenImage(null)}
              className="absolute top-4 right-4 bg-black/60 hover:bg-black/80 text-white p-1.5 rounded-full flex items-center justify-center"
            >
              ✕
            </button> */}
            <img
              src={fullscreenImage.url}
              alt="Fullscreen"
              className="rounded-lg max-w-[90vw] max-h-[85vh] object-contain cursor-pointer bg-white"
              onClick={() => setFullscreenImage(null)}
            />
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
